// @flow

import {
  ADD_JOBS,
  JOB_ADD,
  JOB_UPDATE,
  JOB_LOG_UPDATE,
  JOB_PROGRESS_UPDATE,
} from "../actions"
import { listReplace } from "../utils"

const jobUpdate = ( state, type, action ) => {
  const rest = state.filter( job => job.id !== action.jobId )
  const toUpdate = state.find( job => job.id === action.jobId ) || { id: action.jobId }
  if ( type === JOB_LOG_UPDATE ) {
    return [
      ...rest,
      {
        ...toUpdate,
        log: ( toUpdate.log || "" ) + action.log,
      },
    ]
  } else if ( type === JOB_PROGRESS_UPDATE ) {
    return [
      ...rest,
      {
        ...toUpdate,
        progress: action.progress,
      },
    ]
  } else if ( type === JOB_UPDATE ) {
    return [
      ...rest,
      {
        ...toUpdate,
        ...action.job,
      },
    ]
  } else {
    return state
  }
}

export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case ADD_JOBS:
    return listReplace( state, action.jobs )
  case JOB_LOG_UPDATE:
  case JOB_PROGRESS_UPDATE:
  case JOB_UPDATE:
    return jobUpdate( state, action.type, action )
  case JOB_ADD:
    return listReplace( state, [ action.job ] )
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/jobs.jsx